import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCustomerAddress } from '../../api/apiStorefront';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useUpdateCustomerAddress = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async ({ id, addressData }) => {
      const response = await updateCustomerAddress(id, addressData);
      return response.data;
    },
    onSuccess: () => {
      toast.success(t('address.updated', 'Address updated successfully!'));
      queryClient.invalidateQueries(['customer-addresses']);
    },
    onError: (error) => {
      const message = error.response?.data?.message || t('address.updateError', 'Failed to update address');
      toast.error(message);
    },
  });
};
